import { isNil } from 'lodash';

export const getNodeId = (adapter, node) => {
  const id = node && (adapter.nodeId ? adapter.nodeId(node) : node.id);

  if (isNil(id)) {
    throw new Error('nodeId should always return value in Tree');
  }
  return id;
};

export const getNodeParentId = (adapter, node) => {
  const id = adapter.nodeParentId ? adapter.nodeParentId(node) : node.parentId;
  if (isNil(id) && id !== null) {
    throw new Error(
      `nodeParentId for node ${getNodeId(adapter, node)} is [${id}]`,
    );
  }
  return id;
};

export const getNodeTitle = (adapter, node, options) =>
  adapter.nodeTitle ? adapter.nodeTitle(node, options) : node.name;

export const getNodeTooltip = (adapter, node, options) =>
  adapter.nodeTooltip
    ? adapter.nodeTooltip(node, options)
    : getNodeTitle(adapter, node, options);

export const nodeIsLeaf = (adapter, node, options) =>
  adapter.nodeIsLeaf ? adapter.nodeIsLeaf(node, options) : true;

export const renderNodeAddons = (adapter, node, nodesMeta) =>
  (adapter.renderNodeAddons && adapter.renderNodeAddons(node, nodesMeta)) ||
  null;
